import * as Styled from "./style";
import { SamplePackageImage } from "~/components/blocks/common/sample-package-image";
import { SamplePlayer } from "~/components/blocks/product/detail/sample-player";
import { SampleVisualImage } from "~/components/blocks/product/detail/sample-visual-image";
import { useImageSrcFormat } from "~/hooks/use-image-src-format";
import { useMatchMedia } from "~/hooks/use-match-media";
import { useRatingBlock } from "~/hooks/use-rating-block";
import type { G_VideoRatingCategory, Maybe } from "~/lib/graphql";

type SampleSeasonAssetProps = {
  sampleMovieUrl: string;
  episodeImage: string;
  keyVisualImage: Maybe<string> | undefined;
  keyVisualWithoutLogoImage: Maybe<string> | undefined;
  packageImage: string;
  videoRatingCategory: G_VideoRatingCategory;
};

export const SampleSeasonAsset = (props: SampleSeasonAssetProps) => {
  const { sampleMovieUrl, episodeImage, keyVisualImage, keyVisualWithoutLogoImage, packageImage, videoRatingCategory } =
    props;

  const { isSpSize } = useMatchMedia();

  const { imageSrcFormat } = useImageSrcFormat({ aspectRatio: "LANDSCAPE" });

  const { disallowAutoPlaySampleMovie } = useRatingBlock();

  /** SP以外かつサンプル動画の情報がある場合、サンプル動画を表示する */
  const isSamplePlayer = !isSpSize && sampleMovieUrl !== "";

  const canShowSampleMovie = isSamplePlayer && !disallowAutoPlaySampleMovie(videoRatingCategory);

  if (episodeImage !== "") {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: episodeImage, size: { w: 1920, h: 1080 } })}
          alt="エピソード末端のサンプル画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }
  if (canShowSampleMovie) {
    return (
      <SamplePlayer
        src={[{ uri: sampleMovieUrl }]}
        posterImage={
          imageSrcFormat({
            imgSrc: episodeImage || keyVisualImage || keyVisualWithoutLogoImage || packageImage,
            size: { w: 1920, h: 1080 },
          }).alternativeSrc
        }
      />
    );
  }

  if (keyVisualImage) {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: keyVisualImage, size: { w: 1920, h: 1080 } })}
          alt="ロゴがあるキービジュアル画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  if (keyVisualWithoutLogoImage) {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: keyVisualWithoutLogoImage, size: { w: 1920, h: 1080 } })}
          alt="ロゴがないキービジュアル画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  if (packageImage) {
    return (
      <>
        <SamplePackageImage packageImageUrl={packageImage} />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  return null;
};
